<template>
  <Head title="Register e-mail" />
  <GuestLayout>
    <article class="">
      <div class="sm:px-5 xl:max-w-[350px]">
        <h2
          class="text-3xl font-semibold text-primary text-left xl:py-6 sm:py-4"
        >
          Email
        </h2>
        <p class="pb-2">
          Cadastre um <strong> email </strong> para acessar a plataforma.
        </p>

        <form @submit.prevent="submit">
          <ul class="grid gap-5 pt-4">
            <li>
              <label class="mb-1 mr-5 flex font-semibold"> Email </label>
              <Input
                placeholder="Exemplo: joao@email.com"
                type="email"
                required
                v-model="form.email"
                :state="state"
              />
            </li>

            <li>
              <label class="mb-1 mr-5 flex font-semibold">
                Confirme seu email
              </label>
              <Input
                placeholder="Exemplo: joao@email.com"
                type="email"
                required
                v-model="emailConfirm"
                :state="state"
              />
            </li>
            <div
              v-if="$page.props.flash.error"
              class="flashError text-[10px] text-error"
            >
              {{ $page.props.flash.error }}
            </div>
            <li>
              <span class="text-xs pt-1 pb-4 grid">
                Enviaremos uma mensagem de confirmação no seu email para
                confirmar se a conta existe.
              </span>

              <button
                class="
                  w-full
                  grid
                  justify-items-center
                  items-center
                  text-primary
                  font-semibold
                  border-primary border
                  rounded
                  hover:bg-gray-500 hover:border-transparent
                  p-1.5
                  sm:mt-6
                "
              >
                Avançar
              </button>
            </li>
          </ul>
        </form>
      </div>
    </article>
    <ValidationErrors :errors="errors" />
  </GuestLayout>
</template>

<script>
import Input from "@/Components/UI/Form/Input.vue";

import GuestLayout from "@/Layouts/Guest.vue";
import Label from "@/Components/Label.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Input,
    Label,
    ValidationErrors,
    Head,
    Link,
    GuestLayout,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: "",
      }),
      errors: [],
      state: "default",
      emailConfirm: "",
    };
  },

  methods: {
    submit() {
      this.errors = [];
      if (this.form.email !== this.emailConfirm) {
        this.errors.push("Parece que o email não está igual");
        this.state = "error";
      } else {
        this.state = "success";
        console.log(this.form);
        sessionStorage.setItem("email", this.form.email);
        this.$inertia.post("register/email", this.form);
      }
    },
  },
};
</script>
